import { Button, ButtonGroup, Spinner } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';
import { useState } from 'react';

const ExportButtons = ({ reportType, filters, onExport, disabled }) => {
    const [exporting, setExporting] = useState(null);

    const handleExport = async (format) => {
        setExporting(format);
        try {
            await onExport(format);
        } finally {
            setExporting(null);
        }
    };

    return (
        <ButtonGroup>
            <Button
                variant="danger"
                size="sm"
                onClick={() => handleExport('pdf')}
                disabled={disabled || exporting !== null}
                style={{ minWidth: '100px' }}
            >
                {exporting === 'pdf' ? (
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-1"
                        />
                        Exporting...
                    </>
                ) : (
                    <>
                        <FaFilePdf className="me-1" />
                        Export PDF
                    </>
                )}
            </Button>

        </ButtonGroup>
    );
};

export default ExportButtons;
